import { MEDIA_FILE_LIST_ACTION } from "../configs/Constants";

export const mediaFileListActions = (data: object) => {
  return { type: MEDIA_FILE_LIST_ACTION, payload: data };
};
